
import React from 'react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { ChefHat, X } from 'lucide-react';
import { Recipe } from '@/types/recipe';

interface SelectedRecipesListProps {
  selectedRecipes: Recipe[];
  onRemoveRecipe: (recipeId: string) => void;
}

const SelectedRecipesList: React.FC<SelectedRecipesListProps> = ({
  selectedRecipes,
  onRemoveRecipe
}) => {
  if (selectedRecipes.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      <Label>Selected Recipes ({selectedRecipes.length})</Label>
      <div>
        <div className="space-y-2">
          {selectedRecipes.map((recipe) => (
            <div
              key={recipe.id}
              className="flex items-center justify-between p-3 border rounded-lg bg-muted/50"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <ChefHat size={16} className="text-muted-foreground flex-shrink-0" />
                <div className="min-w-0">
                  <p className="font-medium truncate">{recipe.title}</p>
                  <p className="text-xs text-muted-foreground">
                    Prep: {recipe.prepTime || 'N/A'} • Cook: {recipe.cookTime || 'N/A'}
                  </p>
                </div>
              </div>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemoveRecipe(recipe.id)}
              >
                <X size={16} />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectedRecipesList;
